export default {
  OPERACION_TIPO_PREGUNTA: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
